import { isCustomChartTypeSlugChartConfig } from '../../../schemas';
export const getGroupByDimensions = (args) => {
    const chartConfig = args.vizTool?.chartConfig;
    if (isCustomChartTypeSlugChartConfig(chartConfig))
        return undefined;
    return chartConfig?.groupBy ?? undefined;
};
//# sourceMappingURL=getGroupByDimensions.js.map